import { ResponseInterceptor } from '../interceptor'
import { AxiosError } from 'axios'
import { clearAuthToken } from '../utils'

export default class Unauthorized extends ResponseInterceptor {
  public static INTERCEPTOR_KEY = 'unauthorized'

  public async reject(error: AxiosError) {
    if (error.response && error.response.status === 401) {
      // Check if running locally - skip redirect for local development
      const isLocalhost = typeof window !== 'undefined' && (
        window.location.hostname === 'localhost' || 
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.includes('192.168.') ||
        window.location.hostname.includes('10.0.') ||
        window.location.hostname.includes('172.')
      )

      // Only redirect to login if not running locally
      if (!isLocalhost) {
        clearAuthToken()
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
}
